import { makeStyles } from 'tss-react/mui';

import { isLightMode } from 'pages/Landings/utils';

export default makeStyles({ name: 'MenuItem' })((theme) => {
    return {
        root: {
            display: 'flex',
            padding: '12px 16px',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 100,
            gap: 10,
            color: isLightMode(theme) ? '#232323' : '#fff',
            fontSize: 15,
            fontWeight: 500,
            lineHeight: '16px',
            transition: 'all 0.2s',
            border: '1px solid transparent',
            textDecoration: 'none',
            '&:hover': {
                background: isLightMode(theme) ? '#00000020' : '#FFFFFF40'
            },
            '&:active': {
                borderColor: isLightMode(theme) ? '#00000020' : '#FFFFFF40'
            }
        },
        popper: {
            margin: '0 !important',
            padding: '0 !important',
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box'
        },
        tooltip: {
            margin: '0 !important',
            padding: '0 !important',
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
            font: 'inherit !important',
            background: 'transparent !important',
            color: 'inherit !important',
            backdropFilter: 'blur(16px)'
        }
    };
});
